import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { memberApi } from '@formosa/shared/api/member';
import { resolveSafeUserVisibleError } from '@formosa/shared/i18n/safeUserVisibleError';
import { formatDateTime } from '@formosa/shared/utils/formatDateTime';
import { resolveMemberMediaUrl } from '@formosa/shared/utils/mediaUrl';
import { resolveNewsApiLang } from '@formosa/shared/utils/newsLang';
import { useTravelTranslation } from '../../app/TravelLocaleContext';
import { ErrorState, LoadingState } from '../../components/ui';
import './member-content-notices.css';

export default function AnnouncementDetailPage() {
  const { announcementId } = useParams();
  const { locale } = useTravelTranslation();
  const [phase, setPhase] = useState('loading');
  const [error, setError] = useState('');
  const [detail, setDetail] = useState(null);
  const [reloadToken, setReloadToken] = useState(0);

  useEffect(() => {
    let cancelled = false;
    async function load() {
      setPhase('loading');
      setError('');
      try {
        const data = await memberApi.announcementCenterDetail(announcementId, {
          lang: resolveNewsApiLang(locale),
        });
        if (!cancelled) {
          setDetail(data || null);
          setPhase('ready');
        }
      } catch (cause) {
        if (!cancelled) {
          setError(resolveSafeUserVisibleError(cause, () => '無法載入公告。', 'travel.common.loadFailed'));
          setPhase('error');
        }
      }
    }
    load();
    return () => {
      cancelled = true;
    };
  }, [announcementId, locale, reloadToken]);

  return (
    <main className="member-content-notices" data-testid="announcement-detail-page">
      <Link to="/announcements" className="member-content-notices__back">
        返回公告列表
      </Link>
      {phase === 'loading' ? <LoadingState label="載入公告…" /> : null}
      {phase === 'error' ? (
        <ErrorState
          title="無法載入公告"
          description={error}
          retryable
          onRetry={() => setReloadToken((value) => value + 1)}
          retryLabel="重新載入"
        />
      ) : null}
      {phase === 'ready' && detail ? (
        <article className="member-content-notices__detail">
          <h1>{detail.title || '公告'}</h1>
          {detail.createTime ? (
            <time dateTime={detail.createTime}>{formatDateTime(detail.createTime)}</time>
          ) : null}
          {detail.imgUrl ? (
            <img src={resolveMemberMediaUrl(detail.imgUrl)} alt="" />
          ) : null}
          {detail.content ? (
            <div
              className="member-content-notices__html"
              // Member 公告內容為營運 CMS HTML；沿用 Member 端既有展示契約。
              dangerouslySetInnerHTML={{ __html: detail.content }}
            />
          ) : null}
        </article>
      ) : null}
    </main>
  );
}
